/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProductTag from './product-tag';
import ProductTagDetail from './product-tag-detail';
import ProductTagUpdate from './product-tag-update';
import ProductTagDeleteDialog from './product-tag-delete-dialog';

const ProductTagRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProductTag />} />
    <Route path="new" element={<ProductTagUpdate />} />
    <Route path=":id">
      <Route index element={<ProductTagDetail />} />
      <Route path="edit" element={<ProductTagUpdate />} />
      <Route path="delete" element={<ProductTagDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProductTagRoutes;
